// CARO. Casa de estilo — cart line identity (product + optional size).
//
// One line per (product, size). Unsized products keep their bare product id, so
// every existing key (client cart, stock_holds.product_id) stays valid. `#` can
// never appear in a product id/slug (SLUG_RE), so the split is unambiguous.
// Kept in its own module (re-exported by `@/lib/cart`) so `@/lib/holds` can use
// it without an import cycle.

const SEP = '#';

/** Key of a cart line / stock hold: `id` for unsized products, `id#size` otherwise. */
export function lineKey(productId: string, size?: string | null): string {
  return size ? `${productId}${SEP}${size}` : productId;
}

/** Product id a line key belongs to (inverse of `lineKey`). */
export function productIdOfLineKey(key: string): string {
  const i = key.indexOf(SEP);
  return i === -1 ? key : key.slice(0, i);
}
